import { Sparkles, Hash, MessageCircle } from "lucide-react";

const BENEFITS = [
  { icon: Sparkles, title: "Oroscopo settimanale personalizzato", text: "Ogni lunedì, calcolato sul tuo tema natale e sui transiti reali della settimana." },
  { icon: Hash, title: "Numerologia quotidiana", text: "Ogni mattina la previsione del tuo Giorno Personale, con notifica." },
  { icon: MessageCircle, title: "Assistente Leo", text: "Per approfondire ogni lettura con una conversazione dedicata." },
];

export const PremiumBenefits = () => (
  <div className="text-left space-y-4 mb-8" data-testid="premium-benefits">
    <p className="text-[10px] uppercase tracking-[0.2em] text-amber-400/70 text-center mb-5">
      Incluso nell'abbonamento
    </p>
    {BENEFITS.map(({ icon: Icon, title, text }) => (
      <div key={title} className="flex items-start gap-3.5">
        <span className="shrink-0 w-8 h-8 rounded-full border border-amber-500/40 bg-amber-500/10 flex items-center justify-center">
          <Icon className="w-3.5 h-3.5 text-amber-300" />
        </span>
        <div>
          <p className="font-display text-amber-100 text-sm">{title}</p>
          <p className="text-purple-300/60 text-xs leading-relaxed mt-0.5">{text}</p>
        </div>
      </div>
    ))}
  </div>
);
